import { PrimitiveTypes, useKamstrupIntl } from "@kamstrup/kamstrup-intl";
import { useCallback } from "react";
import { TranslationKeyType } from "./types";

export const useTranslation = () => {
  const { translateText, translateDate, translateNumber, translateDateToParts, locale } =
    useKamstrupIntl();

  const translateString = useCallback(
    (key: TranslationKeyType, values?: Record<string, PrimitiveTypes>) => {
      return translateText(key, values);
    },
    [translateText]
  );

  const translateId = useCallback(
    (id: string, values?: Record<string, PrimitiveTypes>) => translateText(id, values),
    [translateText]
  );

  return {
    translateString: translateString,
    translateId: translateId,
    translateDate: translateDate,
    translateNumber: translateNumber,
    translateDateToParts: translateDateToParts,
    locale: locale
  };
};
